import { Box } from 'wix-style-react';
import { BusinessInfoLine } from '../InvoicesBusinessInfo/BusinessInfoLine';
import * as React from 'react';
export var BusinessName = function (_a) {
    var name = _a.name;
    return name ? (React.createElement(Box, { paddingBottom: "8px" },
        React.createElement(BusinessInfoLine, { dataHook: "business-name", verticalLayout: true, textProps: { color: '#474747', weight: 'bold' }, value: name }))) : null;
};
//# sourceMappingURL=BusinessName.js.map